/**
 * Created by mauget on 9/5/16.
 */

import listService      from 'ListService.js';
import sequenceService  from 'SequenceService.js';
import constants        from 'Constants.js';

class ConnectionVO {

    // id: sequenceService.nextDomId(),
    // scriptId: listService.currentBehaviorInstanceId,
    // initCoords: {left: 0, top: 0},
    // name: 'My Connection',
    // srcCommand: listService.getBehaviorObject(  w1.model.id ),
    // destCommand: listService.getBehaviorObject( w2.model.id ),
    // srcDot:  Number(model.get('srcDot')),
    // destDot: Number(model.get('destDot'));

    // Model is the line's model
    // w1 and w2 are BackBone widgets (rendered on HTML5 canvas, not as HTML controls)
    constructor( srcView, destView, srcDot, destDot, opts = {} ) {

        this.id = opts.id || sequenceService.nextDomId();
        this.scriptId = opts.scriptId || listService.currentBehaviorInstanceId;
        this.initCoords = opts.initCoords || {left: 0, top: 0};
        this.name = opts.name || 'Connection';

        this.srcCommand = srcView;
        this.destCommand = destView;

        const
            srcDotn  = Number(srcDot),
            destDotn = Number(destDot);

        this.srcDot  = srcDot;
        this.destDot = destDot;

        // fancy line stuff
        this.ctrlPoint1x = opts.ctrlPoint1x;
        this.ctrlPoint1y = opts.ctrlPoint1y;
        this.ctrlPoint2x = opts.ctrlPoint2x;
        this.ctrlPoint2y = opts.ctrlPoint2y;
        this.lineType    = opts.lineType || constants.LINE_TYPE_STRAIGHT;

        this.textBoxHeight = opts.textBoxHeight ||  20;
        this.textBoxWidth  = opts.textBoxWidth  || 100;
    }


}

export default ConnectionVO;
